<template>
    <div class="contract-paper">
        <div class="header">
            <div class="wrap">
                <img class="logo" src="https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/email/flypig.png" alt="">
                <div class="title">
                    房屋租賃電子合約書
                </div>
                <div class="btn-group">
                    <button v-if="this.$route.query.type==='release'" class="default-button" @click="releaseContract()">確認退租</button>
                </div>
            </div>
        </div>
        <div class="view-contract" v-html="contract"></div>
    </div>
</template>
<script>
import { 
    apiContractThrowLease,
    apiGetContractPaper
    } from "@/apis/api.js"; 
import { 
    previewContractVersion as bizPreviewContractVersion,
    previewEditContractVersion as bizPreviewEditContractVersion,
    } from "@/apis/company/contractVersion.js";
import { 
    previewContractVersion,
    previewEditContractVersion,
    } from "@/apis/landlord/contractVersion.js"; 
export default {
    data () {
        return {
            contract: null
        }
    },
    mounted () {
        // console.log(this.$route.query.cid)
        // this.$analytics.logEvent('查看合約', { screen_name: '查看合約'})
        const mode = this.$route.query.mode
        if(mode && mode === 'version'){
            if(this.$route.query.accountType === 'LANDLORD'){
                if(this.$route.query.isEdit === 'true'){
                    this.previewEditContractVersion('LANDLORD')
                }else{
                    this.getContractVersion(this.$route.query.cid,null, 'LANDLORD')
                }
            }else{
                if(this.$route.query.isEdit === 'true'){
                    this.previewEditContractVersion('COMPANY')
                }else{
                    if(this.$route.query.contractType){
                        this.getContractVersion(null, this.$route.query.contractType, 'COMPANY')
                    }else{
                        this.getContractVersion(this.$route.query.cid, null,'COMPANY')
                    }
                }
                
            }
        }else{
            this.getContractPapet(this.$route.query.cid)
        }
        
    },
    methods: {
        getContractVersion: function (cid, contractType, accountType) {
            let params = {}
            if(cid){
                params = {
                    contractVersionId: cid
                }
            }else{
                params = {
                    contractMode: contractType
                }
            }
            if(accountType === 'LANDLORD'){
                previewContractVersion(params)
                .then( res => {
                    console.log(res)
                    if(res.data.status == 'SUCCESS'){
                        this.contract = res.data.result
                    }else{
                        alert(res.data.errorMsg);
                    }
                })
                .catch( err => {
                    console.log(err)
                })
            }else{
                bizPreviewContractVersion(params)
                .then( res => {
                    console.log(res)
                    if(res.data.status == 'SUCCESS'){
                        this.contract = res.data.result
                    }else{
                        alert(res.data.errorMsg);
                    }
                })
                .catch( err => {
                    console.log(err)
                })
            }
            
        },
        previewEditContractVersion: function (accountType) {
            const inputData = localStorage.getItem('previewContract')
            let data = JSON.parse(inputData)
            console.log(data)
            if(accountType === 'LANDLORD'){
                previewEditContractVersion(data)
                .then( res => {
                    console.log(res)
                    if(res.data.status == 'SUCCESS'){
                        this.contract = res.data.result
                    }else{
                        alert(res.data.errorMsg);
                    }
                })
                .catch( err => {
                    console.log(err)
                })
            }else{
                bizPreviewEditContractVersion(data)
                .then( res => {
                    console.log(res)
                    if(res.data.status == 'SUCCESS'){
                        this.contract = res.data.result
                    }else{
                        alert(res.data.errorMsg);
                    }
                })
                .catch( err => {
                    console.log(err)
                })
            }
        },
        getContractPapet: function (cid) {
            let data = cid
            apiGetContractPaper(data)
            .then( res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    this.contract = res.data.result
                }else{
                    alert(res.data.errorMsg);
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        releaseContract: function () {
            let data = this.cid
            apiContractThrowLease(data)
            .then(res => {
                if(res.data.status = "SUCCESS"){
                    this.$router.push({name: 'leasemanagementdefault'})
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '已通知房客進行退租',type: 'success'})
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg, type: 'error'})
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err, type: 'error'})
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.contract-paper{
    .header{
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 89px;
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        background-color: #ffffff;
        top: 0px;
        left: 0;
        z-index: 6;
        .wrap  {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            max-width: 1440px;
            >.title{
                font-size: 28px;
                font-weight: 500;
                color: #ff9275;
            }
            .logo{
                position: absolute;
                left: 90px;
                width: 60px;
                height: 60px;
                margin-bottom: 0px;
            }
            .btn-group{
                position: absolute;
                display: flex;
                align-items: center;
                z-index: 2;
                right: 90px;
                .default-button{
                    position: relative;
                    width: 120px;
                }
            }
        }
    }
    .view-contract{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 29px;
    }
}
@media (max-width: 960px) {
    .contract-paper{
        .header{
            height: 49px;
            .wrap{
                >.title{
                    font-size: 16px;
                }
                .logo{
                    left: 15px;
                    width: 40px;
                    height: 40px;
                }
                .btn-group{
                    .default-button{
                        position: relative;
                        width: 100px;
                        height: 33px;
                    }
                }
            }
        }
    }
}
@media (max-width: 540px) {
    .contract-paper{
        .header{
            .wrap{
                .logo{
                    left: 13px;
                }
                .btn-group{
                    right: 13px;
                }
            }
        } 
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/landlord/LeaseManagementPages/ContractPaper.vue